export const MAX_RATING = 5
export const NEGATIVE_REVIEW_MAX_RATING = 3

export const APP_DOWNLOAD_BASE_URL =
  'https://app.backmarket.com/j4lA/reviewcollection'
